import { NotificationType } from './notification-type.enum';
import { IZPNotification } from './notification.model';

export class ZPNotification implements IZPNotification {
  message: string
  icon: string
  title: string
  additionalInfo: string
  type: NotificationType
  public constructor(message: string, icon?: string, title?: string, additionalInfo?: string, type: NotificationType = NotificationType.Info) {
    this.message = message;
    this.icon = icon;
    this.title = title;
    this.additionalInfo = additionalInfo;
    this.type = type;
  }
}
